import React, {useEffect, useState} from "react";
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CustomTable from "../../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import *  as snackbarActions from "../../../actions/snackbarActions";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import {Link} from "react-router-dom";
import {Container} from "../../DoctorsModule/doctorStyles";
import {LoadingGif} from "../../Utils/Loader";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import {faVials} from "@fortawesome/free-solid-svg-icons/faVials";
import {RightAlignedContainer} from "../../Utils/styledComponents";
import {useDebounce} from "../useDebounce";
import MakeLabRequisition from "./MakeLabRequisition";
import {ReceiveLabDispatchStock} from "./ReceiveLabDispatchStock";
import LabStockAdjustment from "./LabStockAdjustment";


const headData = [
    {id: 'sl', numeric: false, disablePadding: false, label: 'Sl'},
    {id: 'product', numeric: false, disablePadding: false, label: 'Product'},
    {id: 'unit', numeric: false, disablePadding: false, label: 'Unit'},
    {id: 'stock', numeric: false, disablePadding: false, label: 'Stock'},
];

const LabStockList = (props) => {
    const {actions} = props
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState('idle');
    const [stockList, setList] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [total_count, setCount] = useState(0);
    const [debouncedInputValue] = useDebounce(searchValue, 500)
    const [openRequisition, setRequisition] = useState(false)
    const [isSubmitted,setIsSubmitted] = useState('idle')
    const [openReceive, setOpenReceive] = useState(false)
    const [openAdjustment, setOpenAdjustment] = useState(false)


    const isResolved = isSubmitted === 'resolved'

    useEffect(() => {
        if (!debouncedInputValue){
            return
        }
        setActivePage(1)

    }, [debouncedInputValue]);

    useEffect(() => {
        setLoading('pending');
        const formData = new FormData();
        formData.append('category_id', '')
        formData.append('search', debouncedInputValue)
        formData.append('page', activePage)
        formData.append('to_store', "Labs")
        formData.append('categories', "3,4")
        axios.post(`${config.smsUrl}/cpharmacy/pharmacy_stock`, formData).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = !dt.stock ? [] : dt.stock;
            const count = !dt.total_count ? 0 : dt.total_count;
            setLoading('success');
            setCount(count)
            setList(arr);

        }).catch((err) => {
            logoutErrorMessage(err, null, actions);
            setLoading('error');
        })

    }, [activePage, debouncedInputValue, isResolved]);


    const handleSearch = (event) => {
        setSearchValue(event.target.value)
    };

    const handleChangePage = (page) => {
        setActivePage(page)
    }

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };

    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isError = loading === 'error';

    const {openBar, type, message} = props.snackbars;
    return (
        <div data-testid="lab-stock-list" className='journals'>
            <PageTitle title="Lab Stock"/>
            <SubHeader title="Laboratory" subTitle='Lab Stock'>
                <FontAwesomeIcon icon={faVials}/>
            </SubHeader>

            <MakeLabRequisition {...{openRequisition, setRequisition, setIsSubmitted, isSubmitted, actions}}/>
            <ReceiveLabDispatchStock {...{openReceive, setOpenReceive, actions,isSubmitted, setIsSubmitted}}/>
            <LabStockAdjustment {...{openAdjustment, setOpenAdjustment, isSubmitted, setIsSubmitted, actions}}/>

            <Container>
                <div className="mui-tables">
                    <RightAlignedContainer>
                        <button type="button" onClick={()=>setRequisition(true)}
                                className="btn  btn-sm sms-btn mb-2 small-btn mr-2">Make Requisition
                        </button>
                        <button className='btn btn-sm sms-info-btn mb-2 mr-2' id="receive-store-stock"
                                onClick={()=>setOpenReceive(true)}>Receive stock
                        </button>
                        <button type="button" onClick={() => setOpenAdjustment(true)}
                                className="btn sms-gray-btn  small-btn mb-1 btn-sm">Adjust Stock
                        </button>
                    </RightAlignedContainer>
                    <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                    <CustomTable title="Stock List" term={searchValue} records={10} activePage={activePage}
                                 headData={headData} handler={handleSearch} total_count={total_count}
                                 data={stockList} colSpan={5}
                                 handleChangeNextPage={handleChangePage} customPage>
                        <TableBody>
                            {isLoading ? <TableRow>
                                <TableCell colSpan={headData.length} align="center"><LoadingGif/></TableCell>
                            </TableRow> : null}
                            {isSuccess ? stockList.length > 0 ?
                                <>
                                    {stockList.slice(0, 10)
                                        .map((item, index) => {
                                            const count = ((activePage - 1) * 10) + index + 1;
                                            return (
                                                <TableRow
                                                    hover
                                                    key={item.product_id}>
                                                    <TableCell>{count}</TableCell>
                                                    <TableCell><Link
                                                        to={{pathname: `/reports/productlog/lab/${item.product_id}`}}>{item.product_name}{item.country_of_origin ? ` - ${item.country_of_origin}` : null}</Link></TableCell>
                                                    <TableCell>{item.name}</TableCell>
                                                    <TableCell>{item.stock}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    <TableRow>
                                        <TableCell colSpan={headData.length} align="right"><strong>Total
                                            Count: {total_count}</strong></TableCell>
                                    </TableRow>
                                </> : <TableRow>
                                    <TableCell colSpan={headData.length} align="center">No records found</TableCell>
                                </TableRow> : null}
                            {isError ? <TableRow>
                                <TableCell colSpan={headData.length} align="center">The server did not return a valid
                                    response</TableCell>
                            </TableRow> : null}
                        </TableBody>
                    </CustomTable>
                </div>
            </Container>
        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(LabStockList);
